// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".title1[data-v-17fbc980]{color:#018a38;font-size:25px;font-weight:500}.title1-line[data-v-17fbc980]{border-radius:15px;border-top:3px solid #d1161c;width:60px}", ""]);
// Exports
module.exports = exports;
